<template>
    <div>
        <KpFieldlabel v-if="label" :label="label" :disabled="disabled" :info-text="infoText" />
        <v-text-field
            :disabled="disabled"
            class="inputfield"
            v-bind="$attrs"
            :type="iconType === 'password' ? 'password' : 'text'"
            v-model:model-value="modelValue"
        >
            <template v-slot:prepend-inner>
                <v-icon class="icon-margin" size="x-small" v-if="iconType === 'tel'"
                    >fas fa-phone</v-icon
                >
                <v-icon class="icon-margin" size="x-small" v-if="iconType === 'email'"
                    >fas fa-at</v-icon
                >
                <v-icon class="icon-margin" size="x-small" v-if="iconType === 'password'"
                    >fas fa-key</v-icon
                >
            </template>
        </v-text-field>
    </div>
</template>

<script setup lang="ts">
import KpFieldlabel from './kp-fieldlabel.vue'

type IconType = 'tel' | 'email' | 'text' | 'password'

const modelValue = defineModel<string | null>({ default: null })

const {
    label = null,
    iconType = null,
    infoText = null,
    disabled = false,
} = defineProps<{
    label?: string
    iconType?: IconType
    infoText?: string | null
    disabled?: boolean
}>()
</script>

<style lang="css" scoped>
.inputfield {
    margin-left: -1rem;
}
.icon-margin {
    margin-left: 0.25rem;
}
</style>
